import Storage from "good-storage";
import Config from "@/config/index.js";
import { dataGather } from "@/utils/aLiLogTracking.js";
import { isClient } from "@/utils/isTerminal.js";

export function currentUrlToParams(key = null) {
  let paramsUrl = window.location.href.split("?");
  if (paramsUrl.length < 2) return key ? null : {};
  let paramsArr = paramsUrl[1].split("&");
  let paramsData = {};
  paramsArr.forEach(r => {
    let data = r.split("=");
    paramsData[data[0]] = data[1];
  });
  if (key) return paramsData.hasOwnProperty(key) ? paramsData[key] : null;
  return paramsData;
}

/**
 * 将对象转换为?a=5&b=7形式
 * @param obj
 * @param firstStr
 * @returns {string|string}
 */
export function obj2StrParams(obj, firstStr = "?") {
  let params = firstStr;

  for (let p in obj) {
    params += p + "=" + obj[p] + "&";
  }
  return params.substring(0, params.length - 1);
}

/*
获取当前url
http://192.168.49.71:8081/ => http://192.168.49.71:8081/
http://192.168.49.71:8081/mm/ => http://192.168.49.71:8081/mm/
http://192.168.49.71:8081/mm/index.html => http://192.168.49.71:8081/mm/
http://192.168.49.71:8081/mm/ff/login.html?id=55 => http://192.168.49.71:8081/mm/ff/

页面名字不能能匹配除\w 的地址，也就是说你的页面名字名字必须由a-z、A-Z、0-9，以及下划线组成才可以。
*/
export function getCurrentUrl() {
  let u = window.location.href.split("?")[0];
  let match = u.match(/(\S+\/)\w+.html/i);
  return match && Array.isArray(match) && match.length > 1 ? match[1] : u;
}

/**
 * 重置对象（会修改原始对象）
 * @param object
 * @param defaultVal
 */
export function resetObject(object, defaultVal = {}) {
  for (let k in object) {
    if (defaultVal.hasOwnProperty(k)) {
      object[k] = defaultVal[k];
    } else {
      if (Array.isArray(object[k])) object[k] = [];
      if ("string" == typeof object[k]) object[k] = "";
      if ("number" == typeof object[k]) object[k] = null;
      if ("boolean" == typeof object[k]) object[k] = false;
    }
  }
}

/**
 * 对象赋值（会修改原始对象）
 * @param object
 * @param valObject
 */
export function fillerLeft(object, valObject = {}) {
  for (let k in object) {
    if (valObject.hasOwnProperty(k)) {
      object[k] = valObject[k];
    }
  }
}

/**
 * 获取用户信息
 * @param key
 * @returns {null|*|undefined|{}}
 */
export function getUserInfo(key = null) {
  let userInfo = Storage.get(Config.userInfoKey) || {};
  if (key) return userInfo.hasOwnProperty(key) ? userInfo[key] : "";
  return userInfo || {};
}

/**
 * 设置用户信息
 * @param user
 * @returns {*}
 */
export function setUserInfo(user) {
  Storage.set(Config.userInfoKey, user);
  return user;
}

/**
 * 获取Token
 * @returns {*|undefined}
 */
export function getToken() {
  return Storage.get(Config.tokenKey);
}

/**
 * 设置Token
 * @param token
 * @returns {*|undefined}
 */
export function setToken(token) {
  return Storage.set(Config.tokenKey, token);
}

/**
 * 移除Token
 * @returns {*}
 */
export function removeToken() {
  return Storage.remove(Config.tokenKey);
}

//将接口返回的上报数据整合成数组
export function filterArray(array) {
  let temp = [];
  for (let i = 0; i < array.length; i++) {
    for (let n = array[i].start; n <= array[i].end; n++) {
      temp.push(n);
    }
  }
  return temp;
}

//整合数据上报
export function arrange(arr) {
  let result = [];
  let temp = [];
  arr
    .sort(function(source, dest) {
      return source - dest;
    })
    .concat(Infinity)
    .reduce(function(source, dest) {
      temp.push(source);
      if (dest - source > 1) {
        result.push(temp);
        temp = [];
      }
      return dest;
    });
  return result;
}

//数据上报数据整合
export function dataReport(array) {
  let temp = arrange(array);
  let result = [];
  if (Array.isArray(temp)) {
    for (let i = 0; i < temp.length; i++) {
      if (Array.isArray(temp[i])) {
        result.push({ start: temp[i][0], end: temp[i][temp[i].length - 1] });
      }
    }
  }
  return result;
}

//数据埋点
export function dataBurialPoint(page = "", event = "", properties = "") {
  //因为阿里云是后面接入的，为了尽量少改动代码，这里再次调用dataGather，下次在项目中埋点请直接使用@/utils/aLiLogTracking 下的dataGather方法
  dataGather(page, event, properties);
}

/**
 * 获取机构信息
 * @returns {*|undefined}
 */
export function getOrgInfo() {
  return Storage.get(Config.orgInfo);
}

/**
 * 设置机构信息
 * @param token
 * @returns {*|undefined}
 */
export function setOrgInfo(orgInfo) {
  return Storage.set(Config.orgInfo, orgInfo);
}

/**
 * 移除机构信息
 * @returns {*}
 */
export function removeOrgInfo() {
  return Storage.remove(Config.orgInfo);
}

/**
 * 获取机构orgId
 * @returns {*|undefined}
 */
export function getOrgId() {
  return Storage.get(Config.orgId);
}

/**
 * 设置机构orgid
 * @param token
 * @returns {*|undefined}
 */
export function setOrgId(orgId) {
  return Storage.set(Config.orgId, orgId);
}

/**
 * 移除机构orgid
 * @returns {*}
 */
export function removeOrgId() {
  return Storage.remove(Config.orgId);
}

export function goToH5LoginSystem() {
  window.location.href = "./phoneLoginInputPhone.html";
}

export function deviceInfo() {
  if (isClient) return "APP";
  let userAgentInfo = navigator.userAgent;
  let Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  ];
  let flag = "PC";
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = "PHONE";
      break;
    }
  }
  return flag;
}

// export function addEventListenerPageShow() {
//   let Event = {
//     addHandler: function(element, type, handler) {
//       if (element.addEventListener) {
//         element.addEventListener(type, handler, false);
//       } else if (element.attachEvent) {
//         element.attachEvent("on" + type, handler);
//       } else {
//         element["on" + type] = handler;
//       }
//     },
//     removeHandler: function(element, type, handler) {
//       //移除监听事件
//       if (element.removeEventListener) {
//         element.removeEventListener(type, handler, false);
//       } else if (element.detachEvent) {
//         element.detachEvent("on" + type, handler);
//       } else {
//         element["on" + type] = null;
//       }
//     }
//   };
//   Event.addHandler(window, "pageshow", res => {
//     console.log(res);
//     if (
//       res.persisted ||
//       (window.performance && window.performance.navigation.type == 2)
//     ) {
//       setTimeout(() => {
//         window.location.reload();
//       }, 500);
//     }
//   });
//   Event.addHandler(window, "pagehide", function() {
//     Event.removeHandler(window, "pageshow");
//   });
// }
